import { JarvisTvConnectType, JarvisTvProduct } from '@vfde-sails/availability';
import { AdditionalPageOptions } from '../../interface';
import { WS10_LIST } from '../../container/App/constant';
import { HEADLINE_BASE_CLASSNAME } from '@vfde-brix/ws10/headline';

export const getFootnoteDetails = (
    { tvConnectFootnotes, tvConnectBvFootnotes }: AdditionalPageOptions,
    tvConnect?: JarvisTvProduct,
    tvConnectBv?: JarvisTvProduct,
) => {
    if (tvConnect) {
        return tvConnectFootnotes[tvConnect.tvConnectType];
    }

    switch (tvConnectBv?.tvConnectType) {
        case JarvisTvConnectType.Zuhause:
        case JarvisTvConnectType.ZuhausePresale:
            return tvConnectBvFootnotes.zuhause;
        case JarvisTvConnectType.Start:
            return tvConnectBv.priceAddons.discountedPrice?.price.value === 0
                ? tvConnectBvFootnotes.tvConnectFree
                : tvConnectBvFootnotes.tvConnectForRemainingPrice;
        case JarvisTvConnectType.StartPresale:
            return tvConnectBv.priceAddons.discountedPrice?.price.value === 0
                ? tvConnectBvFootnotes.tvConnectPreFree
                : tvConnectBvFootnotes.tvConnectPreForRemainingPrice;
    }

    return undefined;
};

const getTvConnectContent = (
    originalContent: string,
    cmsProps: AdditionalPageOptions,
    tvConnect?: JarvisTvProduct,
    tvConnectBv?: JarvisTvProduct,
) => {
    const footnoteDetails = getFootnoteDetails(cmsProps, tvConnect, tvConnectBv);

    if (!footnoteDetails) {
        return originalContent;
    }

    const containerEl = document.createElement('div');

    containerEl.innerHTML = originalContent;

    const [ headlineEl ] = containerEl.getElementsByClassName(HEADLINE_BASE_CLASSNAME);
    const [ listEl ] = containerEl.getElementsByClassName(WS10_LIST);

    headlineEl.innerHTML = footnoteDetails.headline;
    listEl.innerHTML = '';

    for (const text of Object.values(footnoteDetails.list)) {
        const li = document.createElement('li');

        li.innerHTML = text;

        listEl.appendChild(li);
    }

    return containerEl.innerHTML;
};

export default {
    getTvConnectContent,
};
